'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { PasswordPolicyEditForm } from '@/features/identity-policy';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/settings/password/edit')({
  component: PasswordPolicyEditPage
});
function PasswordPolicyEditPage() {
  return <PasswordPolicyEditForm backTo="/settings/authentication/settings/password" />;
}